import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import set from 'lodash/set'
import get from 'lodash/get'
import merge from 'lodash/merge'
import isPlainObject from 'lodash/isPlainObject'

function mergeSettings(a, b) {
  if (isPlainObject(a) && isPlainObject(b)) {
    return merge({}, b, a)
  }
  return a
}

export const withSettings = WrappedComponent => (
  @inject(['websites'])
  @observer
  class WebsiteSettings extends Component {
    getSettingsAt = (path, fallback={}) => {
      const got = get(this.props.websites.current.settings, path, fallback)
      return mergeSettings(got, fallback)
    }

    getDynamicFieldsFor = what => {
      const website = this.props.websites.current
      const email_signature = get(this.props.websites.current.settings, 'email.defaults.email_signature', '')

      const site = {
        website_phone: website.display_phone,
        website_email: website.display_email,
        website_name: website.name,
        website_url: website.root_url,
        email_signature_image: website.signature_image,
      }

      const lead = {
        lead_first_name: 'John',
        lead_last_name: 'Howard',
        lead_email: 'john.howard2321@gmail.com',
        search_party_url: `${website.default_url}/invite/123`,
      }

      const listing = {
        address: '10045 Calle Real',
        city: 'Laguna Beach',
        state: 'CA',
        zip: '92651',
        bedrooms: '3',
        bathrooms: '2',
        price: '$250,000',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
      }

      return {
        defaults: {
          email_signature_image: website.signature_image,
        },
        new_lead: {
          ...lead,
          ...site,
          email_signature,
        },
        subscriptions: {
          ...lead,
          ...site,
          search_subscription_name: 'Riverview Condos Over 200k',
          search_subscription_link: `${website.default_url}/search/123`,
          email_signature,
        },
        quick_reponse: {
          ...lead,
          ...site,
          email_signature,
        },
        listing_data: {
          ...listing,
          email_signature,
        }
      }[what]
    }

    setSettingsAt = (path, value) => {
      const settings = set(this.props.websites.current.settings, path, value)
      return this.props.websites.save({ settings })
    }

    render() {
      if (!this.props.websites.current) return null

      return (
        <WrappedComponent
          getSettingsAt={this.getSettingsAt}
          setSettingsAt={this.setSettingsAt}
          getDynamicFieldsFor={this.getDynamicFieldsFor}
          website={this.props.websites.current}
          {...this.props} />
      )
    }
  }
)



// WEBPACK FOOTER //
// client/components/sections/website/settings/withSettings.js